import React from "react"
import ReactDOM from "react-dom"
import Geocode from "react-geocode"

import App from "./App"

Geocode.setApiKey("AIzaSyBwlx8Eit4Ch3iaTfzsKsxVfdlRoQ_h5wU")
Geocode.setLanguage("it")

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById("root")
)
